
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ldhE1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a09ceb2f2eff13b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $eiA8Z = parcelRequire("eiA8Z");


var $iesbi = parcelRequire("iesbi");


var $8CZUH = parcelRequire("8CZUH");

var $6xdDU = parcelRequire("6xdDU");


var $dh538 = parcelRequire("dh538");


var $bQUgf = parcelRequire("bQUgf");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $gtD4K = parcelRequire("gtD4K");


var $d7ZU3 = parcelRequire("d7ZU3");


var $hgeg8 = parcelRequire("hgeg8");


var $hkTaH = parcelRequire("hkTaH");

var $ahUGI = parcelRequire("ahUGI");

var $2UWDO = parcelRequire("2UWDO");



var $5Ilz2 = parcelRequire("5Ilz2");

var $4HWgE = parcelRequire("4HWgE");

var $2zaaI = parcelRequire("2zaaI");

var $ocPnd = parcelRequire("ocPnd");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $aFUXX = parcelRequire("aFUXX");


var $6fnsQ = parcelRequire("6fnsQ");

function $3c9355e70c559dd2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3c9355e70c559dd2$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $aFUXX.akEditorUnitZIndex),
    minHeight: "var(--ds-space-300, 24px)",
    padding: `${"var(--ds-space-250, 20px)"} ${"var(--ds-space-500, 40px)"}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: "'none'",
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$6fnsQ.N400})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-neutral-subtle, ${$6fnsQ.N0})`,
    borderRadius: "var(--ds-radius-small, 3px)"
});
const $3c9355e70c559dd2$export$adb608be33961c98 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $aFUXX.akEditorUnitZIndex),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${$6fnsQ.N300})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: "var(--ds-space-300, 24px)",
    textAlign: 'right',
    boxShadow: "'none'"
});
const $3c9355e70c559dd2$export$85d913f0b727a278 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $aFUXX.akEditorUnitZIndex),
    color: "var(--ds-text-subtle, #505258)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: "var(--ds-space-300, 24px)",
    textAlign: 'right',
    boxShadow: "'none'"
});
const $3c9355e70c559dd2$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-250, 20px)"} ${"var(--ds-space-500, 40px)"}`,
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    overflow: 'auto',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${$6fnsQ.N400})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-neutral-subtle, ${$6fnsQ.N0})`
});
const $3c9355e70c559dd2$export$53f1d5ea8de3d7c = {
    name: "1hwd3vz",
    styles: "background:var(--ds-background-neutral-subtle, #fff);content:'';display:block;height:var(--ds-space-025, 2px);left:0;position:absolute;top:0;right:0;width:100%;min-width:604px"
};
const $3c9355e70c559dd2$export$a7db06668cad9adb = {
    name: "163b9uc",
    styles: "min-width:524px;width:100%;position:relative;display:flex;justify-content:space-between"
};
const $3c9355e70c559dd2$export$4e0c71f277ca26b3 = {
    width: '44%',
    '& > ul': {
        padding: 0
    }
};
const $3c9355e70c559dd2$export$120ff0929b202a6d = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: `${"var(--ds-space-250, 20px)"} 0`,
    display: 'flex',
    justifyContent: 'space-between'
});
const $3c9355e70c559dd2$export$9bb6a6f2774dc082 = {
    '&': {
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(24),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N400)})`,
        letterSpacing: 'normal',
        lineHeight: 1.42857142857143
    }
};
const $3c9355e70c559dd2$export$a09cb1d3ccdca387 = {
    name: "sy8d3f",
    styles: "display:flex;flex-direction:column;flex-shrink:0;gap:var(--ds-space-150, 12px)"
};
const $3c9355e70c559dd2$export$4e2c9f64cbda9a3c = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $3c9355e70c559dd2$export$9c7d691958d83aa0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $6fnsQ.B300)})`}`,
        outlineOffset: "var(--ds-space-025, 2px)"
    }
});


const $cceff92b40424310$var$codeSm = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    width: "var(--ds-space-300, 24px)",
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center'
});
const $cceff92b40424310$var$codeMd = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    width: '50px',
    textAlign: 'center'
});
const $cceff92b40424310$var$codeLg = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center',
    paddingInline: 'space.150',
    backgroundColor: 'color.background.neutral'
});
const $cceff92b40424310$var$navigationKeymaps = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).navigateToEditorToolbar),
            type: 'navigation',
            keymap: ()=>(0, $hgeg8.navToEditorToolbar)
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).navigateToFloatingToolbar),
            type: 'navigation',
            keymap: ()=>(0, $hgeg8.navToFloatingToolbar)
        }
    ];
const $cceff92b40424310$export$e8eb56737f1ebbe8 = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).bold),
            type: 'strong',
            keymap: ()=>(0, $hgeg8.toggleBold),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "**", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $2zaaI.toolbarMessages).bold), "**"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).italic),
            type: 'em',
            keymap: ()=>(0, $hgeg8.toggleItalic),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "*", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $2zaaI.toolbarMessages).italic), "*"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).underline),
            type: 'underline',
            keymap: ()=>(0, $hgeg8.toggleUnderline)
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).strike),
            type: 'strike',
            keymap: ()=>(0, $hgeg8.toggleStrikethrough),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "~~", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $2zaaI.toolbarMessages).strike), "~~"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).subscript),
            type: 'subsup',
            keymap: ()=>(0, $hgeg8.toggleSubscript)
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).superscript),
            type: 'subsup',
            keymap: ()=>(0, $hgeg8.toggleSuperscript)
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading1),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading1),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "#"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading2),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading2),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "##"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading3),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading3),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "###"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading4),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading4),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "####"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading5),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading5),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "#####"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading6),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading6),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "######"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).normal),
            type: 'paragraph',
            keymap: ()=>(0, $hgeg8.setNormalText)
        },
        {
            name: formatMessage((0, $5Ilz2.messages).orderedList),
            type: 'orderedList',
            keymap: ()=>(0, $hgeg8.toggleOrderedList),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "1."), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $5Ilz2.messages).unorderedList),
            type: 'bulletList',
            keymap: ()=>(0, $hgeg8.toggleBulletList),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "*"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).blockquote),
            type: 'blockquote',
            keymap: ()=>(0, $hgeg8.toggleBlockQuote),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, '>'), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).codeblock),
            type: 'codeBlock',
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "```"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).horizontalRule),
            type: 'rule',
            keymap: ()=>(0, $hgeg8.insertRule),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "---"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).link),
            type: 'link',
            keymap: ()=>(0, $hgeg8.addLink),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "[", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $4HWgE.toolbarInsertBlockMessages).link), "](http://a.com)"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).code),
            type: 'code',
            keymap: ()=>(0, $hgeg8.toggleCode),
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "`", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $2zaaI.toolbarMessages).code), "`"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action),
            type: 'taskItem',
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "[]"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision),
            type: 'decisionItem',
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "<>"), ' ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emoji),
            type: 'emoji',
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, ":"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mention),
            type: 'mention',
            autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "@"))
        },
        {
            name: formatMessage((0, $hkTaH.alignmentMessages).alignLeft),
            type: 'alignment',
            keymap: ()=>(0, $hgeg8.alignLeft)
        },
        {
            name: formatMessage((0, $hkTaH.alignmentMessages).alignCenter),
            type: 'alignment',
            keymap: ()=>(0, $hgeg8.alignCenter)
        },
        {
            name: formatMessage((0, $hkTaH.alignmentMessages).alignRight),
            type: 'alignment',
            keymap: ()=>(0, $hgeg8.alignRight)
        }
    ];
const $cceff92b40424310$var$quickInsertAskAI = ({ formatMessage: formatMessage })=>({
        name: formatMessage((0, $2zaaI.toolbarMessages).askAI),
        type: 'AI',
        keymap: ()=>(0, $hgeg8.askAIQuickInsert)
    });
const $cceff92b40424310$var$otherFormatting = ({ formatMessage: formatMessage })=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return [
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).clearFormatting),
            type: 'clearFormatting',
            keymap: ()=>(0, $hgeg8.clearFormatting)
        },
        {
            name: formatMessage((0, $ocPnd.messages).undo),
            type: 'undo',
            keymap: ()=>(0, $hgeg8.undo)
        },
        {
            name: formatMessage((0, $ocPnd.messages).redo),
            type: 'redo',
            keymap: ()=>(0, $hgeg8.redoAlt)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).pastePlainText),
            type: 'paste',
            keymap: ()=>(0, $hgeg8.pastePlainText)
        },
        {
            name: formatMessage((0, $ahUGI.annotationMessages).createComment),
            type: 'annotation',
            keymap: ()=>(0, $hgeg8.addInlineComment)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).CheckUncheckActionItem),
            type: 'checkbox',
            keymap: ()=>(0, $hgeg8.toggleTaskItemCheckbox)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).selectTableRow),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    css: (0, $3c9355e70c559dd2$export$a09cb1d3ccdca387)
                }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2190")), /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2192")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).selectTableColumn),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    css: (0, $3c9355e70c559dd2$export$a09cb1d3ccdca387)
                }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2191")), /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2193")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).InsertTableColumn),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    css: (0, $3c9355e70c559dd2$export$a09cb1d3ccdca387)
                }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "=")), /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "-")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).InsertTableRow),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    css: (0, $3c9355e70c559dd2$export$a09cb1d3ccdca387)
                }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "]")), /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "[")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).selectColumnResize),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    css: (0, $3c9355e70c559dd2$export$a09cb1d3ccdca387)
                }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: browser.mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, browser.mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, browser.mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "C")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).highlightColor),
            type: 'highlight',
            keymap: ()=>(0, $hgeg8.toggleHighlightPalette)
        }
    ];
};
const $cceff92b40424310$var$resizeInformationFormatting = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).increaseSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.increaseMediaSize)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).decreaseSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.decreaseMediaSize)
        }
    ];
const $cceff92b40424310$var$newResizeInformationFormatting = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).increaseElementSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.increaseMediaSize)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).decreaseElementSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.decreaseMediaSize)
        }
    ];
const $cceff92b40424310$var$focusTableResizeHandleFormatting = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).focusTableResizeHandle),
            type: 'navigation',
            keymap: ()=>(0, $hgeg8.focusTableResizer)
        }
    ];
const $cceff92b40424310$var$openCellOptionsFormattingtoFormat = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).openCellOptions),
            type: 'image',
            keymap: ()=>(0, $hgeg8.focusToContextMenuTrigger)
        }
    ];
const $cceff92b40424310$var$imageAutoFormat = {
    name: 'Image',
    type: 'image',
    autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $cceff92b40424310$var$codeLg
        }, "![", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $iesbi.helpDialogMessages).altText), "](http://www.image.com)"))
};
const $cceff92b40424310$var$quickInsertAutoFormat = ({ formatMessage: formatMessage })=>({
        name: formatMessage((0, $iesbi.helpDialogMessages).quickInsert),
        type: 'quickInsert',
        autoFormatting: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $cceff92b40424310$var$codeLg
            }, "/"))
    });
const $cceff92b40424310$export$49b39f11f17c13f0 = (schema, intl, imageEnabled, quickInsertEnabled, aiEnabled)=>{
    const supportedBySchema = $cceff92b40424310$export$e8eb56737f1ebbe8(intl).filter((format)=>schema.nodes[format.type] || schema.marks[format.type]);
    return [
        ...aiEnabled && (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true) ? [
            $cceff92b40424310$var$quickInsertAskAI(intl)
        ] : [],
        ...$cceff92b40424310$var$navigationKeymaps(intl),
        ...$cceff92b40424310$var$otherFormatting(intl),
        ...supportedBySchema,
        ...imageEnabled ? [
            $cceff92b40424310$var$imageAutoFormat
        ] : [],
        ...quickInsertEnabled ? [
            $cceff92b40424310$var$quickInsertAutoFormat(intl)
        ] : [],
        ...$cceff92b40424310$var$focusTableResizeHandleFormatting(intl),
        ...(0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) ? $cceff92b40424310$var$newResizeInformationFormatting(intl) : $cceff92b40424310$var$resizeInformationFormatting(intl),
        ...$cceff92b40424310$var$openCellOptionsFormattingtoFormat(intl)
    ];
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $804cB = parcelRequire("804cB");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 















var $7hXDW = parcelRequire("7hXDW");


var $iXCQx = parcelRequire("iXCQx");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766















const $ea2fedb55b62ba84$var$codeLg = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center',
    paddingInline: 'space.150',
    backgroundColor: 'color.background.neutral'
});
const $ea2fedb55b62ba84$var$codeMd = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    width: '50px',
    textAlign: 'center'
});
const $ea2fedb55b62ba84$var$codeSm = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    width: "var(--ds-space-300, 24px)",
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center'
});
const $ea2fedb55b62ba84$var$getKeyParts = (keymap)=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    let shortcut = keymap[browser.mac ? 'mac' : 'windows'];
    if (browser.mac) shortcut = shortcut.replace('Alt', 'Opt');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return shortcut.replace(/\-(?=.)/g, ' + ').split(' ');
};
const $ea2fedb55b62ba84$export$fc7974054e48aed3 = [
    'table',
    'emoji',
    'mention',
    'quickInsert'
];
const $ea2fedb55b62ba84$export$bad16e05505d5562 = (keymap)=>{
    const keyParts = $ea2fedb55b62ba84$var$getKeyParts(keymap);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $3c9355e70c559dd2$export$4e2c9f64cbda9a3c)
    }, keyParts.map((part, index)=>{
        if (part === '+') return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            key: `${keyParts}-${index}`
        }, ' + '));
        else if (part === 'Cmd') return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeSm,
            key: `${keyParts}-${index}`
        }, "\u2318"));
        else if ([
            'ctrl',
            'alt',
            'opt',
            'shift'
        ].indexOf(part.toLowerCase()) >= 0) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeMd,
            key: `${keyParts}-${index}`
        }, part));
        else if ([
            'f9',
            'f10'
        ].indexOf(part.toLowerCase()) >= 0) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeLg,
            key: `${keyParts}-${index}`
        }, part));
        else if (part.toLowerCase() === 'enter') return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            "data-editor-help-dialog-enter-keymap": "true",
            xcss: $ea2fedb55b62ba84$var$codeSm,
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: `${keyParts}-${index}`
        }, "\u23CE");
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeSm,
            key: `${keyParts}-${index}`
        }, part.toUpperCase()));
    })));
};


const $bd52c85f06645d53$var$ModalFooter = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $dh538.fg)('platform_editor_fix_help_dialog_color_contrast') ? (0, $3c9355e70c559dd2$export$85d913f0b727a278) : (0, $3c9355e70c559dd2$export$adb608be33961c98)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), {
        ...(0, $iesbi.helpDialogMessages).helpDialogTips,
        values: {
            keyMap: (0, $ea2fedb55b62ba84$export$bad16e05505d5562)((0, $hgeg8.openHelp))
        }
    }));
var $bd52c85f06645d53$export$2e2bcd8739ae039 = $bd52c85f06645d53$var$ModalFooter;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766












var $a4eZN = parcelRequire("a4eZN");





var $hmuev = parcelRequire("hmuev");


var $8TTLA = parcelRequire("8TTLA");


var $3gadb = parcelRequire("3gadb");


const $d0911650ef99a30b$var$toolbarFocusStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // In Firefox/Safari, when user clicks (as suppose to press Enter) on the help quick insert item, focus ring may not be present
    // Hence we manually force it
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    'button:focus:not(:focus-visible)': {
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
        outlineOffset: "var(--ds-space-025, 2px)"
    }
});
const $d0911650ef99a30b$var$ModalHeader = (0, $gmMgo.default)(({ intl: { formatMessage: formatMessage }, onClose: onClose })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3c9355e70c559dd2$export$38e42c68cf43b5d4)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7hXDW.default), {
        size: "large"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $iesbi.helpDialogMessages).editorHelp)), onClose ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $d0911650ef99a30b$var$toolbarFocusStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $iesbi.helpDialogMessages).closeHelpDialog),
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8TTLA.CloseButton), {
        onClick: onClose,
        label: formatMessage((0, $iesbi.helpDialogMessages).closeHelpDialog)
    }))) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        onClick: onClose,
        title: formatMessage((0, $iesbi.helpDialogMessages).closeHelpDialog),
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: formatMessage((0, $iesbi.helpDialogMessages).closeHelpDialog),
            color: "currentColor",
            spacing: "spacious"
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        css: (0, $3c9355e70c559dd2$export$9c7d691958d83aa0)
    }))));
});
var $d0911650ef99a30b$export$2e2bcd8739ae039 = $d0911650ef99a30b$var$ModalHeader;




const $7a777e0b3d085d40$export$6da19a24bf249f17 = ({ formatting: formatting, onClose: onClose })=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d0911650ef99a30b$export$2e2bcd8739ae039), {
        onClose: onClose
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3c9355e70c559dd2$export$2a82ddc22e8c7fbb),
        tabIndex: 0
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3c9355e70c559dd2$export$53f1d5ea8de3d7c)
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3c9355e70c559dd2$export$a7db06668cad9adb)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3c9355e70c559dd2$export$4e0c71f277ca26b3)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7hXDW.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $iesbi.helpDialogMessages).keyboardShortcuts)), /*#__PURE__*/ (0, $9K4OG.jsx)("ul", null, formatting.filter((form)=>{
        const keymap = form.keymap && form.keymap();
        return keymap && keymap[browser.mac ? 'mac' : 'windows'];
    }).map((form)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const keymap = form.keymap;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("li", {
            css: (0, $3c9355e70c559dd2$export$120ff0929b202a6d),
            key: `textFormatting-${form.name}`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), null, form.name), (0, $ea2fedb55b62ba84$export$bad16e05505d5562)(keymap())));
    }), formatting.filter((form)=>(0, $ea2fedb55b62ba84$export$fc7974054e48aed3).indexOf(form.type) !== -1).filter((form)=>form.autoFormatting).map((form)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const autoFormatting = form.autoFormatting;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("li", {
            css: (0, $3c9355e70c559dd2$export$120ff0929b202a6d),
            key: `autoFormatting-${form.name}`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), null, form.name), autoFormatting()));
    }))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3c9355e70c559dd2$export$53f1d5ea8de3d7c)
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3c9355e70c559dd2$export$4e0c71f277ca26b3)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7hXDW.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $iesbi.helpDialogMessages).markdown)), /*#__PURE__*/ (0, $9K4OG.jsx)("ul", null, formatting.filter((form)=>(0, $ea2fedb55b62ba84$export$fc7974054e48aed3).indexOf(form.type) === -1).map((form)=>form.autoFormatting && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("li", {
            key: `autoFormatting-${form.name}`,
            css: (0, $3c9355e70c559dd2$export$120ff0929b202a6d)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, form.name), form.autoFormatting())))))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bd52c85f06645d53$export$2e2bcd8739ae039), null));
};
var $7a777e0b3d085d40$export$2e2bcd8739ae039 = $7a777e0b3d085d40$export$6da19a24bf249f17;


const $c0916096e7125ec3$var$Modal = ({ formatting: formatting })=>{
    const { onClose: onClose } = (0, $804cB.useModal)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7a777e0b3d085d40$export$6da19a24bf249f17), {
        formatting: formatting,
        onClose: onClose
    });
};
var $c0916096e7125ec3$export$2e2bcd8739ae039 = $c0916096e7125ec3$var$Modal;


const $8a09ceb2f2eff13b$var$selector = (states)=>{
    return {
        isVisible: states.helpDialogState?.isVisible,
        imageEnabled: states.helpDialogState?.imageEnabled,
        aiEnabled: states.helpDialogState?.aiEnabled
    };
};
const $8a09ceb2f2eff13b$var$HelpDialog = ({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, quickInsertEnabled: quickInsertEnabled, intl: intl })=>{
    const { isVisible: isVisible, imageEnabled: imageEnabled, aiEnabled: aiEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'helpDialog'
    ], $8a09ceb2f2eff13b$var$selector);
    const closeDialog = (0, $42omo.useCallback)(()=>{
        const { state: { tr: tr }, dispatch: dispatch } = editorView;
        (0, $bQUgf.closeHelpCommand)(tr, dispatch);
    }, [
        editorView
    ]);
    const handleEsc = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Escape' && isVisible) closeDialog();
    }, [
        closeDialog,
        isVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleEsc);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleEsc);
        };
    }, [
        handleEsc
    ]);
    const formatting = (0, $cceff92b40424310$export$49b39f11f17c13f0)(editorView.state.schema, intl, imageEnabled, quickInsertEnabled, aiEnabled);
    const label = (0, $dh538.fg)('platform_editor_fix_help_modal_header') ? intl.formatMessage((0, $iesbi.helpDialogMessages).editorHelp) : undefined;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6xdDU.default), null, isVisible ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8CZUH.default), {
        label: label,
        width: "large",
        onClose: closeDialog,
        testId: "help-modal-dialog"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c0916096e7125ec3$export$2e2bcd8739ae039), {
        formatting: formatting
    })) : null);
};
var $8a09ceb2f2eff13b$export$2e2bcd8739ae039 = (0, $gmMgo.default)($8a09ceb2f2eff13b$var$HelpDialog);

});


//# sourceMappingURL=ui.8240735a.js.map
